(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brewclick-product-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-bc-thumbnail]');
    if (thumbnail) {
      const gallery = thumbnail.closest('.bc-product__media');
            const mainImage = gallery?.querySelector('[data-bc-main-image]');
      const track = gallery?.querySelector('[data-bc-gallery-track]');
      const thumbnailButtons = Array.from(gallery?.querySelectorAll('[data-bc-thumbnail]') || []);
      const slideIndex = thumbnailButtons.indexOf(thumbnail);
      if (window.matchMedia('(max-width: 749px)').matches && track && slideIndex >= 0) {
        track.scrollTo({ left: slideIndex * track.clientWidth, behavior: 'smooth' });
      } else if (mainImage) {
        mainImage.src = thumbnail.dataset.bcMainSrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.bcAlt || '';
      }
  gallery.querySelectorAll('[data-bc-thumbnail]').forEach((button) => {
          const selected = button === thumbnail;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      return;
    }

    const toggle = event.target.closest('[data-bc-color-toggle]');
    if (toggle) {
      const slot = toggle.closest('[data-bc-color-slot]');
      const menu = slot?.querySelector('[data-bc-color-menu]');
      if (!menu) return;
      const willOpen = menu.hidden;
      document.querySelectorAll('[data-bc-color-menu]').forEach((item) => { item.hidden = true; });
      document.querySelectorAll('[data-bc-color-toggle]').forEach((item) => { item.setAttribute('aria-expanded', 'false'); });
      menu.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    const colorButton = event.target.closest('[data-bc-color]');
    if (colorButton) {
      const slot = colorButton.closest('[data-bc-color-slot]');
      const image = slot?.querySelector('[data-bc-color-image]');
      const name = slot?.querySelector('[data-bc-color-name]');
      const property = slot?.querySelector('[data-bc-property]');
      if (image) { image.src = colorButton.dataset.bcSrc; image.removeAttribute('srcset'); image.alt = colorButton.dataset.bcColor + ' BrewClick camera'; }
      if (name) name.textContent = colorButton.dataset.bcColor;
      if (property) property.value = colorButton.dataset.bcColor;
      const menu = slot?.querySelector('[data-bc-color-menu]');
      const button = slot?.querySelector('[data-bc-color-toggle]');
      if (menu) menu.hidden = true;
      if (button) button.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.bc-bundle-card input[type="radio"]')) return;
    document.querySelectorAll('[data-bc-bundle-option]').forEach((option) => {
      const active = option.querySelector('.bc-bundle-card input[type="radio"]')?.checked;
      option.querySelectorAll('[data-bc-property]').forEach((input) => { input.disabled = !active; });
    });
  });

  document.querySelectorAll('[data-bc-bundle-option]').forEach((option) => {
    const active = option.querySelector('.bc-bundle-card input[type="radio"]')?.checked;
    option.querySelectorAll('[data-bc-property]').forEach((input) => { input.disabled = !active; });
  });

  document.querySelectorAll('.bc-reviews').forEach((reviews) => {
    const track = reviews.querySelector('[data-bc-reviews-track]');
    const cards = Array.from(reviews.querySelectorAll('[data-bc-review-card]'));
    const dots = Array.from(reviews.querySelectorAll('[data-bc-review-dot]'));
    if (!track || cards.length === 0) return;

    const updateDots = () => {
      const index = cards.reduce((closest, card, cardIndex) => {
        const currentDistance = Math.abs(card.offsetLeft - track.scrollLeft);
        const closestDistance = Math.abs(cards[closest].offsetLeft - track.scrollLeft);
        return currentDistance < closestDistance ? cardIndex : closest;
      }, 0);
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };

    track.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  });

  document.querySelectorAll('.bc-bundle-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.bcSubmitting === 'true') return;

      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const selectedOption = selectedVariant?.closest('[data-bc-bundle-option]');
      if (!selectedVariant || !selectedOption) return;

      const properties = {};
      selectedOption.querySelectorAll('input[type="hidden"][name^="properties["]:not(:disabled)').forEach((input) => {
        const propertyName = input.name.slice(11, -1);
        properties[propertyName] = input.value;
      });

      const items = [];
      selectedOption.querySelectorAll('[data-bc-addon-id]:checked:not(:disabled)').forEach((input) => {
        items.push({ id: Number(input.value), quantity: 1 });
      });
      items.push({ id: Number(selectedVariant.value), quantity: 1, properties });

      const submitButton = form.querySelector('.bc-button--wide[type="submit"]');
      form.dataset.bcSubmitting = 'true';
      if (submitButton) submitButton.disabled = true;

      try {
        const response = await fetch(form.dataset.bcCartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Unable to add selected items to cart.');
        window.location.assign(form.dataset.bcCartUrl);
      } catch (error) {
        form.dataset.bcSubmitting = 'false';
        if (submitButton) submitButton.disabled = false;
        window.alert(error.message);
      }
    });
  });

  document.querySelectorAll('.bc-product').forEach((section) => {
    const originalButton = section.querySelector('.bc-button--wide[type="submit"]');
    const stickyCart = section.querySelector('[data-bc-sticky-cart]');
    const stickyButton = section.querySelector('[data-bc-sticky-submit]');
    if (!originalButton || !stickyCart || !stickyButton) return;

    const updateStickyVisibility = () => {
      const originalRect = originalButton.getBoundingClientRect();
      stickyCart.hidden = originalRect.bottom >= 0;
    };

    const scrollContainer = document.querySelector('.page-wrapper');
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    scrollContainer?.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    updateStickyVisibility();

    stickyButton.addEventListener('click', () => {
      const bundleSection = section.querySelector('#brewclick-bundles');
      bundleSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
